module.exports = __webpack_public_path__ + "static/media/unmute.b2cbf53d.png";